/**
 * Builders for URLs that leave the router — full page navigations and
 * cross-store redirects. These used to be hardcoded to "/olo/{storeId}", which
 * is wrong on a client domain (it would point at the client's own web root).
 */

import { getEmbedConfig } from "./config";

/**
 * URL for a different store, used when a customer switches location.
 *
 * Standalone: /olo/{storeId} on the current host, as before.
 * Embed: we can't know whether the client has a page for that other store, so
 * we send the customer to the canonical hosted URL rather than guessing.
 */
export function storeUrl(storeId: string | number): string {
  const config = getEmbedConfig();

  if (config.mode === "standalone") return `/olo/${storeId}`;

  return `https://order.app2food.com/olo/${storeId}`;
}

/** Legacy v3 ordering platform, for stores not yet migrated. */
export function legacyOrderingUrl(storeId: string | number): string {
  return `https://ordering.app2food.com/order3/${storeId}`;
}

/**
 * Where the router lives, for building links a customer can copy or share.
 * Standalone: https://order.app2food.com/olo/11076/menu
 * Embed/hash: https://website1.com/online-ordering#/menu
 */
export function absoluteRouteUrl(route: string): string {
  const config = getEmbedConfig();
  const path = route.startsWith("/") ? route : `/${route}`;
  const { origin, pathname } = window.location;

  if (config.routerMode === "hash") return `${origin}${pathname}#${path}`;

  return `${origin}${config.basename}${path}`;
}
